import type { AxiosStatic } from "axios";
import axios from "axios";
import {
  dateTransformer,
  v2RequestSnakeCaseTransformer,
  v2ResponseCamelCaseTransformer,
} from "mws-utils";
import type { App } from "vue";

export type FramingApp = {
  axios?: AxiosStatic;
  $http?: AxiosStatic;
} & App;

export default (app: FramingApp) => {
  app.axios = axios;
  app.$http = axios;

  // A simple AxiosTransformer utility to transform date-time strings from
  // JSON data into JS Date objects.
  axios.defaults.transformResponse = [dateTransformer];
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use(v2RequestSnakeCaseTransformer);
  axios.interceptors.response.use(v2ResponseCamelCaseTransformer, (err) => {
    if ("response" in err) {
      err.response = v2ResponseCamelCaseTransformer(err.response);
    }

    throw err;
  });

  app.config.globalProperties.axios = axios;
  app.config.globalProperties.$http = axios;
};
